var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector75(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 330,
    viewBox: "0 0 71 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-236.988 327.982C-218.073 304.594 -213.954 300.888 -194.546 286.072C-189.791 282.441 -180.547 276.73 -169.129 271.274C-165.712 269.64 -162.324 268.157 -158.983 266.798C-135.076 257.105 -108.293 255.736 -81.8423 257.988C-14.3532 263.738 46.5588 227.206 64.3161 171.895C82.1018 116.489 52.8417 54.9628 7.18147 24.9409C1.24023 21.035 -26.7956 3.80491 -57.5553 1.25794C-154.675 -6.81063 -193.483 87.2656 -222.866 230.409C-223.436 233.194 -225.609 246.451 -225.998 249.264L-236.998 327.992L-236.988 327.982Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector75);
export default __webpack_public_path__ + "static/media/vector7-5.b1503c053027133b00b4686b5781c83b.svg";
export { ForwardRef as ReactComponent };